import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { trans } from '@spotahome/soyuz/client';
import { FlexibleDatePicker } from '@spotahome/ui-library';

import GlobalSettings from '../../../../LEGACY/javascripts/cornucopia/core/global-settings';

const datesInputStyles = {
  from: 'ga-search-form-datepicker-from',
  to: 'ga-search-form-datepicker-to'
};

class FormDatePicker extends Component {
  handleOnDateSelect = dates => {
    const mapped = {
      'move-in': dates.moveIn
    };

    if (dates.moveOut) {
      mapped['move-out'] = dates.moveOut;
    }

    this.props.onChange(mapped);
  };

  render() {
    const {
      autoCompleteDates,
      disableDayFnFrom,
      disableDayFnTo,
      flexibleDates,
      fromDate,
      minimumStaying,
      toDate,
      initiallyOpen,
      absolutePosition,
      theme
    } = this.props;

    const datesI18n = {
      dateInPlaceholder: trans('search.filter.date_in'),
      dateOutPlaceholder: trans('search.filter.date_out')
    };

    return (
      <FlexibleDatePicker
        settings={{
          minStay: minimumStaying,
          moveInterval: GlobalSettings.getMoveDatesInterval()
        }}
        autoCompleteDates={autoCompleteDates}
        disableDayFnMoveIn={disableDayFnFrom}
        disableDayFnMoveOut={disableDayFnTo}
        fromDate={fromDate}
        toDate={toDate}
        onChange={this.handleOnDateSelect}
        styles={datesInputStyles}
        i18n={datesI18n}
        initiallyOpen={initiallyOpen}
        absolutePosition={absolutePosition}
        theme={theme}
        {...flexibleDates}
      />
    );
  }
}

const flexibleDatesShape = {
  flexibleMoveIn: PropTypes.bool,
  flexibleMoveOut: PropTypes.bool,
  onFlexibleMoveInChange: PropTypes.func,
  onFlexibleMoveOutChange: PropTypes.func
};

FormDatePicker.propTypes = {
  absolutePosition: PropTypes.bool,
  autoCompleteDates: PropTypes.bool,
  disableDayFnFrom: PropTypes.func,
  disableDayFnTo: PropTypes.func,
  flexibleDates: PropTypes.shape(flexibleDatesShape),
  fromDate: PropTypes.string,
  initiallyOpen: PropTypes.bool,
  minimumStaying: PropTypes.number.isRequired,
  onChange: PropTypes.func.isRequired,
  toDate: PropTypes.string,
  theme: PropTypes.string
};

FormDatePicker.defaultProps = {
  absolutePosition: true,
  autoCompleteDates: false,
  disableDayFnFrom: () => {},
  disableDayFnTo: () => {},
  flexibleDates: null,
  fromDate: '',
  initiallyOpen: false,
  toDate: '',
  theme: 'base'
};

export default FormDatePicker;
